import { where, orderBy, limit, startAfter } from "firebase/firestore";

export const MAX_CALENDARS_LIMIT = 1000;

/**
 * Build Firestore query constraints based on filters.
 * @param {Object} filters
 * @param {DocumentSnapshot|null} lastDoc
 */
export function buildQueryConstraints(filters, lastDoc = null) {
  const constraints = buildCountQueryConstraints(filters);

  constraints.push(limit(MAX_CALENDARS_LIMIT));

  if (lastDoc) {
    constraints.push(startAfter(lastDoc));
  }

  return constraints;
}

/**
 * Build Firestore query constraints based on filters.
 * @param {Object} filters
 * @param {DocumentSnapshot|null} lastDoc
 */
export function buildCountQueryConstraints(filters) {
  const constraints = [];

  if (filters.isActive != null) {
    constraints.push(where("isActive", "==", filters.isActive));
  }

  if (filters.localAuthorityId) {
    constraints.push(where("localAuthorityId", "==", filters.localAuthorityId));
  }

  if (filters.type) {
    constraints.push(where("type", "==", filters.type));
  }

  constraints.push(orderBy("name", "asc"));

  return constraints;
}

/**
 * Client-side filtering for calendars (e.g. search).
 */
export function filterCalendarsClientSide({ calendars, search = "" }) {
  const term = (search || "").toLowerCase();

  if (!term || calendars.length === 0) {
    return calendars;
  }

  return calendars.filter((calendar) => {
    const matches = [];

    if (term) {
      const idMatch = calendar.id && calendar.id.toLowerCase().includes(term);
      const nameMatch = calendar.name && calendar.name.toLowerCase().includes(term);

      matches.push(idMatch || nameMatch);
    }

    return matches.every(Boolean);
  });
}
